import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Col, Row, Modal } from "react-bootstrap";
import logo from "../res/logoBase64.js";
import footer from "../res/footerBase64.js";
import "react-datepicker/dist/react-datepicker.css";
import * as apiMethods from "../res/apiMethods.js";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import "date-fns";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Stack from "@mui/material/Stack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  FormControlLabel,
  Checkbox,
  Accordion,
  Typography,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NumericFormat } from 'react-number-format';
import * as yup from "yup";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import ReactDatePicker from "react-datepicker";
import Sidebar from "../components/Sidebar";
import AccessDenied from "./accessDenied.jsx";
import { generatePDFProyeccion, generatePDF, generateInitialPDF} from '../utils/pdfGenerators';
import { registerLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';
import TodayIcon from '@mui/icons-material/Today';

registerLocale('es', es);

pdfMake.vfs = pdfFonts.vfs;

axios.interceptors.request.use(
  (config) => {
    if (window.sessionStorage.getItem("localToken")) {
      config.headers.Authorization =
        window.sessionStorage.getItem("localToken");
    } else {
      //history.push("/login");
      //window.location.reload();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const Credits = () => {
  const [props, setProps] = useState({
    user: "",
    deudores: [],
    vlrCapital: "",
    plazo: "",
    proximoPeriodoInfo: null,
    estado: "",
    moneda: "",
    fechaAprobacion: new Date(),
    fechaDesembolso: new Date(),
    fechaDesembolsoReal: new Date(),
    transacciones: [],
    vlrInicial: "",
    transaccionesData: [],
    clientesData: [],
    id: "",
    creditos: [],
    fechaPago: new Date(),
    originalId: "",
    montoPago: "",
    cntTransacciones: "",
    pagosUsuario: [],
    garantia: "",
    amortizacion: "",
    auxProxCorte: null,
    auxProxCorteSave: null,
    interes: "",
    interesMoratorio: "",
    seguroVida: "",
    seguroTodoRiesgo: "",
    fechaPagoReciente: null,
    showPaymentsAplicationDialog: false,
    creditos: [],
    fechaPagoProximo: null,
    vlrSegVida: "",
    vlrSegTodoRiesgo: "",
    vlrInteres: "",
    vlrInteresMora: "",
    saldoSegVida: "",
    saldoSegTodoRiesgo: "",
    liquidacionesData: [],
    liquidacionesResp: [],
    proyeccionData: [],
    proyeccion: [],
    estadoReal: "",
    pagosPorCreditos: [],
    detalleData: [],
    labelsDetails: [
      "Saldo Inicial",
      "Movimientos",
      "Aplicacion del pago",
      "Nuevo saldo",
    ],
    resPeriodo: [],
    iteradorPagos: [],
    pasoEdicionLocal: "",
    liquidacionesDataUVR: [],
    detalleDataUVR: [],
    auxTransacciones: [],
    showModal: false,
    showModalDownload: false,
    showModalLiq: false,
    showModalPayment: false,
    showModalPeriod: false,
    fechaRef: "",
    proyState: 0,
    auxFechaPagoReciente: "",
    auxFechaPago: "",
    lastUVR: "",
    emptyPayment: false,
    initialPDF: false,
    files: [],
    financialCode: "",
    showModalDeleteCredito: false,
    showModalDeletePayment: false,
    liquidaciones: [],
    expiryDate: null,
    mortgageDate: null,
    landRegistry: "",
    deedNumber: "",
    notary: "",
    exists: false,
    blockMassiveLiq: false,
    paymentYears: [],
    paymentsPerYear: [],
    periodicReportDialog: true,
    excelCreated: false,
    startDate: new Date(),
    endDate: new Date(),
    startDateSelected: false,
    limiteSuperior: new Date(),
    limiteFecha: new Date(),
    fechaUltimoPago: new Date(),
  });

  const [documentoAdd, setDocumentoAdd] = useState("");
  const [queryClients, setQueryClients] = useState([]);
  const [periodosLiq, setPeriodosLiq] = useState([]);
  const [periodosConPagos, setPeriodosConPagos] = useState([]);

  const months = [
    "ENE",
    "FEB",
    "MAR",
    "ABR",
    "MAY",
    "JUN",
    "JUL",
    "AGO",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const handleChangeDocumento = (event) => {
    setDocumentoAdd(event.target.value);
  };
  const setState = (value, cb) => {
    setProps((prevState) => ({ ...prevState, ...value }));
    if (cb) {
      if (typeof cb === "function") cb();
    }
  };

  const handleShowDeletePayment = (e) => {
    e.preventDefault();
    setState({ showModalDeletePayment: true });
  };

  const handleShowLiq = (e) => {
    e.preventDefault();
    setState({ showModalLiq: true });
  };

  const formatter = new Intl.NumberFormat("en-US", {
    currency: "USD",
  });

  // Helper para formatear valores de celda: detecta números y aplica separador de miles.
  const formatCellValue = (val, opts = {}) => {
    if (val == null || val === "") return "";
    // Si ya viene como string con signo $, devolver tal cual
    if (typeof val === "string" && val.trim().startsWith("$")) return val;
    // Intentar extraer número
    const n = parseFloat(String(val).replace(/[^0-9.-]+/g, ""));
    if (isNaN(n)) return String(val);
    // Opciones: decimales (por defecto 0)
    const minimumFractionDigits = opts.minimumFractionDigits != null ? opts.minimumFractionDigits : 0;
    return new Intl.NumberFormat("en-US", { minimumFractionDigits }).format(n);
  };

  const setCharAt = (str, index, chr) => {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  };

  const definirSegurosModal = async (e) => {
    e.preventDefault();

    const actUsrToken = window.sessionStorage.getItem("localToken");

    try {
      // Mostrar loading
      Swal.fire({
        title: "Extendiendo proyección...",
        allowOutsideClick: false,
      });
      Swal.showLoading();

      // Llamar al backend para extender la proyección
      const response = await axios.post(
        `${apiMethods.BASE_URL}/creditos/${props.id}/proyeccion/extender`,
        {
          fechaPago: props.fechaPago,
        },
        {
          headers: { Authorization: actUsrToken },
        }
      );

      Swal.close();

      // Manejar respuesta
      if (response.data.code === 0) {
        toast.success(
          `Proyección extendida: ${response.data.mesesAgregados} mes(es) agregado(s)`
        );

        // Recargar página después de 1.5 segundos
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(response.data.message || "Error al extender proyección");
      }
    } catch (error) {
      Swal.close();
      console.error("Error extendiendo proyección:", error);
      toast.error(
        error.response?.data?.message || "Error al extender la proyección"
      );
    }
  };

  const enviarPagoModal = (e) => {
    submitHandlerPagos(e);
  };

  const updateblockMassiveLiq = async (e, value, setFieldValue) => {
    setFieldValue("blockMassiveLiq", value); //cambio
    let updateResponse = await axios.patch(
      apiMethods.PATCH_CREDITO_ID + props.id,
      { blockMassiveLiq: value }
    );
  };
  const handleClose = (e) => {
    setState({ showModal: false });
  };

  const handleShowDownload = (e) => {
    e.preventDefault();
    setState({ showModalDownload: true });
  };

  const handleCloseDownload = (e) => {
    setState({ showModalDownload: false });
  };

  const handleShowPayment = (e) => {
    e.preventDefault();
    setState({ showModalPayment: true });
  };

  const handleClosePayment = (e) => {
    setState({ showModalPayment: false });
  };

  const handleShowPeriod = (e) => {
    e.preventDefault();
    setState({ showModalPeriod: true });
  };

  const handleClosePeriod = (e) => {
    setState({ showModalPeriod: false });
  };

  const handleChangeDatePickerPayment = (date, dateTarget) => {
    if (dateTarget === "start") {
      setState({
        startDate: date,
        startDateSelected: true,
      });
    } else {
      setState({
        endDate: date,
      });
    }
  };

  const handleCloseDeleteCredit = (e) => {
    setState({ showModalDeleteCredito: false });
  };

  const handleShowDeleteCredit = (e) => {
    e.preventDefault();
    setState({ showModalDeleteCredito: true });
  };

  const handleCloseDeletePayment = (e) => {
    setState({ showModalDeletePayment: false });
  };

  const handleCloseLiq = (e) => {
    setState({ showModalLiq: false });
  };

  const fixTimeZone = (originalDate) => {
    if (!originalDate) {
      return null;
    }
    
    // Si no es Date, intentar parsearlo
    let dateObj;
    if (originalDate instanceof Date) {
      dateObj = originalDate;
    } else {
      dateObj = parseFlexibleDate(originalDate);
    }
    
    // Validar que la fecha sea válida
    if (!dateObj || isNaN(dateObj.getTime())) {
      console.error('Fecha inválida en fixTimeZone:', originalDate);
      return null;
    }
    
    let dateString = dateObj.toISOString();
    // dateString ejemplo: "2026-10-16T05:00:00.000Z"
    // Posiciones:         0123456789012345678901234
    // Queremos:           "2026-10-16T05:00:00.000Z"
    //                                ^^
    //                               11,12
    
    // Si la hora NO es 05:00, ajustarla
    if (dateString.charAt(11) !== "0" || dateString.charAt(12) !== "5") {
      dateString = setCharAt(dateString, 11, "0");
      dateString = setCharAt(dateString, 12, "5");
    }
    
    return new Date(dateString);
  };

  // Parseador flexible de fechas para formatos como "25-JUN-2021", timestamps y ISO.
  const parseFlexibleDate = (value) => {
    if (!value && value !== 0) return null;
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }

    // Si es número (timestamp)
    if (typeof value === "number") {
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }

    // Si es string numérico puro (timestamp como string)
    if (typeof value === "string" && /^\d+$/.test(value.trim())) {
      const n = Number(value);
      if (!isNaN(n)) {
        const d = new Date(n);
        return isNaN(d.getTime()) ? null : d;
      }
    }

  const s = String(value).trim();

  // Formato DD-MMM-YYYY (p.ej. 25-JUN-2021 o 25-Jun-2021)
  const m = s.match(/^(\d{1,2})[-\s\/]?([A-Za-z]{3,})[-\s\/]?(\d{4})$/);
  if (m) {
    const day = parseInt(m[1], 10);
    const mon = m[2].toLowerCase();
    const year = parseInt(m[3], 10);

    const monthsMap = {
      ene: 0, jan: 0,
      feb: 1,
      mar: 2,
      abr: 3, apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      ago: 7, aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dic: 11, dec: 11,
    };

    const monthIndex = monthsMap[mon];
    if (typeof monthIndex === "number") {
      const d = new Date(year, monthIndex, day);
      if (!isNaN(d.getTime())) return d;
    }
  }

  // Intentar parsear ISO u otros formatos estándar
  const iso = new Date(s);
  if (!isNaN(iso.getTime())) return iso;

  return null;
};

  const onError = (e) => {
    e.preventDefault();
    for (let error in formik.errors) {
      toast.error(formik.errors[error]);
    }
  };

  const validationSchema = yup.object().shape({
    interes: yup.number().min(1, "El valor debe ser mayor a 1"),
    plazo: yup
      .number()
      .min(1, "El plazo mínimo es de 1 meses")
      .max(250, "El plazo máximo es de 250 meses"),
  });

  const formik = useFormik({
    initialValues: props,
    validationSchema: validationSchema,
  });


  // ✅ NUEVO: Calcular automáticamente la fecha de vencimiento
  useEffect(() => {
    const plazo = formik.values.plazo;
    const fechaDesembolso = formik.values.fechaDesembolsoReal;

    // Solo calcular si ambos campos obligatorios están presentes
    if (plazo && fechaDesembolso) {
      const desembolsoDate = new Date(fechaDesembolso);
      
      // Calcular la fecha de vencimiento sumando el plazo en meses
      const fechaVencimiento = new Date(desembolsoDate);
      fechaVencimiento.setMonth(fechaVencimiento.getMonth() + parseInt(plazo));
      
      // Actualizar el campo expiryDate en formik
      formik.setFieldValue("expiryDate", fechaVencimiento);
      
      console.log(`[FECHA VENCIMIENTO] Calculada automáticamente: ${fechaVencimiento.toLocaleDateString('es-CO')}`);
      console.log(`  - Fecha desembolso: ${desembolsoDate.toLocaleDateString('es-CO')}`);
      console.log(`  - Plazo: ${plazo} meses`);
    }
  }, [formik.values.plazo, formik.values.fechaDesembolsoReal]);

  useEffect(() => {
    (async () => {
      document.title = "Créditos";

      let actUsrToken = window.sessionStorage.getItem("localToken");
      setState({
        user: JSON.parse(atob(actUsrToken.split(".")[1])),
      });

      // Obtener creditId de la URL
      const creditId = getLastItem(window.location.href);

      if (creditId !== "credits") {
        setState({ exists: true });

        Swal.fire({ title: "Cargando", allowOutsideClick: false });
        Swal.showLoading();

        try {
          // Usar creditId en lugar de documento
          const response = await axios.get(
            apiMethods.GET_CREDITO_COMPLETO + creditId,
            {
              headers: { Authorization: actUsrToken },
            }
          );

          if (response.data.code === 0) {
            const creditData = response.data.credits;

            creditData.pasoEdicionLocal = creditData.pasoEdicion || 0;

            formik.resetForm({ values: creditData });
            setState({
              ...creditData,
              exists: true,
            });

            // Cargar datos de los clientes (deudores)
            if (creditData.deudores && creditData.deudores.length > 0) {
  

  try {
    const clientesPromises = creditData.deudores.map((deudorDoc) =>
      axios.get(apiMethods.GET_CLIENTE_DOCUMENTO + deudorDoc, {
        headers: { Authorization: actUsrToken },
      }).catch(err => {
        console.error(`[CREDITS] Error cargando cliente ${deudorDoc}:`, err.response?.status);
        return null; // Retornar null en caso de error
      })
    );

    const clientesResponses = await Promise.all(clientesPromises);
    
    // Filtrar respuestas nulas (errores 404)
    const clientesArray = clientesResponses
      .filter(resp => resp !== null)
      .map(resp => resp.data.client);

    

    if (clientesArray.length > 0) {
      // ✅ Actualizar state para el PDF
      setState({
        clientesData: clientesArray,
      });

      // ✅ AGREGAR: Actualizar queryClients para la tabla
      const clientesTabla = clientesArray.map(cliente => ({
        id: cliente.documento,
        tipoDocumento: cliente.tipoDocumento,
        nombre: cliente.nombre
      }));
      
      setQueryClients(clientesTabla);
      
      
    } else {
      console.warn("[CREDITS] ⚠️ No se pudo cargar ningún cliente");
      toast.warn("No se pudieron cargar los datos del cliente");
    }
  } catch (error) {
    console.error("[CREDITS] Error crítico cargando clientes:", error);
    toast.error("Error al cargar los datos del cliente");
  }
}
            
            // En la carga de periodos (línea ~556)
            if (creditData.estado === "aprobado") {
              
              try {
                const respPeriodos = await axios.get(
                  apiMethods.GET_PERIODOS_LIQUIDACION + creditId,
                  { headers: { Authorization: actUsrToken } }
                );
                
                // ✅ AGREGAR ESTE LOG
                
                if (respPeriodos.data.code === 0) {
                  
                  setPeriodosLiq(respPeriodos.data.periodos);
                  
                  // Guardar info del próximo periodo
                  if (respPeriodos.data.proximoPeriodo) {
                    // ✅ AGREGAR ESTE LOG
                    setState({ proximoPeriodoInfo: respPeriodos.data.proximoPeriodo });
                  } else {
                    console.warn("⚠️ No hay proximoPeriodo en la respuesta");
                  }
                }
              } catch (err) {
                console.error("❌ Error cargando periodos:", err);
              }
            } else {
              
            }

            // Cargar periodos con pagos
            if (
              creditData.estado === "aprobado" &&
              creditData.transacciones?.length > 0
            ) {
              try {
                const respPeriodosConPagos = await axios.get(
                  apiMethods.GET_PERIODOS_CON_PAGOS + creditId, // ✅ Usar creditId
                  { headers: { Authorization: actUsrToken } }
                );
                if (respPeriodosConPagos.data.code === 0) {
                  setPeriodosConPagos(respPeriodosConPagos.data.periodos);
                }
              } catch (err) {
                console.error("Error cargando periodos con pagos:", err);
              }
            }
          } else {
            toast.error(response.data.message || "Error al cargar crédito");
          }

          Swal.close();
        } catch (error) {
          Swal.close();
          console.error("Error cargando crédito:", error);
          toast.error("Error al cargar el crédito");
        }
      } else {
        // Modo creación - cargar cliente si está guardado
        if (window.sessionStorage.getItem("clientStored")) {
          try {
            let clientResponse = await axios.get(
              apiMethods.GET_CLIENTE_DOCUMENTO +
                window.sessionStorage.getItem("clientStored")
            );

            if (clientResponse.data.code == 0) {
              let client = {
                id: clientResponse.data.client.documento,
                tipoDocumento: clientResponse.data.client.tipoDocumento,
                nombre: clientResponse.data.client.nombre,
              };
              setQueryClients([client]);
              setDocumentoAdd("");
              window.sessionStorage.removeItem("clientStored");
            } else {
              toast.warn("Cliente no encontrado");
            }
          } catch (error) {
            console.error(error);
          }
        }
      }
    })();
  }, []);

  const handleChangeDatePicker = (date) => {
    setState({
      fechaPago: date,
    });
  };

  const changeHandler = (e) => {
    setState({ [e.target.name]: e.target.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (props.exists) {
      updateCredit(formik.values);
    } else {
      createCredit(formik.values);
    }
  };

  const removeCredit = async (e) => {
    e.preventDefault();
    const actUsrToken = window.sessionStorage.getItem("localToken");
    // Prefer stored localDocument, fallback to props.id or last segment from URL
    let search =
      window.sessionStorage.getItem("localDocument") || props.id || getLastItem(window.location.href);

    if (!search) {
      console.warn("[CREDITS] removeCredit: no credit id available");
      toast.error("No se encontró el identificador del crédito para eliminar");
      return;
    }

    try {
      const response = await axios.post(
        apiMethods.DELETE_CREDITO_COMPLETO + search,
        null,
        {
          headers: { Authorization: actUsrToken },
        }
      );

      if (response.data.code === 0) {
        toast.success("Crédito eliminado exitosamente");
        window.sessionStorage.setItem("success", "true");
        window.sessionStorage.setItem("type", "D");
        window.location.href = "/search/credits";
      } else {
        toast.error(response.data.message || "Error al eliminar");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error al eliminar");
    }
  };

  const paymentsAplicationDialog = () => {
    setState({
      showPaymentsAplicationDialog: !props.showPaymentsAplicationDialog,
    });
  };

  const createSelectItems = () => {
    return periodosConPagos.map((periodo) => (
      <option key={periodo.id} id={periodo.id} value={periodo.label}>
        {periodo.label}
      </option>
    ));
  };

  const createSelectItemsLiq = () => {
    return periodosLiq.map((periodo) => (
      <option key={periodo.id} id={periodo.id} value={periodo.label}>
        {periodo.label}
      </option>
    ));
  };

  const relativePayment = async (e, initialPDF) => {
    if (e) e.preventDefault();

    const actUsrToken = window.sessionStorage.getItem("localToken");
    const decodedPayload = JSON.parse(atob(actUsrToken.split(".")[1]));

    if (periodosLiq.length === 0) {
      toast.error("No hay periodos disponibles para liquidar");
      return;
    }

    // Usar directamente fechaPago del backend
    const periodoSeleccionado = initialPDF
      ? periodosLiq[0]
      : periodosLiq.find(
          (p) =>
            p.id ===
            document.querySelector(".selectorLiq")?.selectedOptions?.[0]?.id
        );

    if (!periodoSeleccionado) {
      toast.error("Seleccione un periodo");
      return;
    }

    const body = {
      idCredito: props.id,
      montoPago: 0,
      fechaPago: periodoSeleccionado.fechaFin, // Usar fecha del backend
      userId: decodedPayload.usrId,
      save: true,
    };

    try {
      await axios.post(apiMethods.CREATE_PAYMENT, body, {
        headers: { Authorization: actUsrToken },
      });

      toast.success(
        periodoSeleccionado.tipo === "activacion"
          ? "Crédito activado"
          : "Periodo liquidado"
      );

      handleCloseLiq();
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response?.data?.message || "Error al procesar");
    }
  };

  useEffect(() => {
    if (props.emptyPayment) {
      const e = new Event("build");
      handleShow(e);
    }
  }, [props.emptyPayment]);

  const submitHandlerPagos = async (e) => {
    e.preventDefault();

    let actUsrToken = window.sessionStorage.getItem("localToken");
    let decodedPayload = JSON.parse(atob(actUsrToken.split(".")[1]));

    // ✅ Usar props.montoPago directamente (ya es el número puro)
    var montoPago = parseFloat(props.montoPago || 0);

    // ✅ Usar props.fechaPago directamente
    if (!props.fechaPago) {
      toast.error("Debe seleccionar una fecha de pago.");
      return;
    }

    // Convertir fecha a formato correcto
    let auxFechaPago = new Date(props.fechaPago);
    auxFechaPago.setHours(auxFechaPago.getHours() - 5);
    auxFechaPago = auxFechaPago
      .toISOString()
      .substring(0, 10)
      .replace(/-/g, "/");

    // ✅ VALIDACIÓN MEJORADA
    const esPagoActivacion =
      montoPago === 0 &&
      (!props.transacciones || props.transacciones.length === 0);

    if (esPagoActivacion) {
    } else if (isNaN(montoPago) || montoPago <= 0) {
      toast.error("Monto inválido. Debe ser mayor a 0.");
      return;
    }

    let body = {
      idCredito: props.id,
      montoPago: montoPago,
      fechaPago: auxFechaPago,
      userId: decodedPayload.usrId,
      save: true,
    };

    try {
      

      const response = await axios.post(apiMethods.CREATE_PAYMENT, body, {
        headers: { Authorization: actUsrToken },
      });

      

      if (esPagoActivacion) {
        toast.success("Crédito activado exitosamente");
      } else {
        toast.success("Pago registrado exitosamente");
      }

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("❌ Error al procesar pago:", error);
      toast.error(error.response?.data?.message || "Error al procesar el pago");
    }
  };

  const isDeleteBlocked = (fTX) => {
    if ((props.user?.roleId != 1 ? false : true) && validateDelete(fTX)) {
      return true;
    } else {
      return false;
    }
  };

  

  const validateDelete = (fTX) => {
    let fechaTX = new Date(fTX);

    if (!isNaN(props.limiteSuperior.getTime())) {
      if (fixTimeZone(fechaTX) > fixTimeZone(props.limiteSuperior)) {
        return true;
      }
      return false;
    }
    return false;
  };

  const isBlocked = () => 
  !([1, 2].includes(props.user?.roleId) && isFechaValida());

  const isFechaValida = () => {
    const auxFechaPago = new Date(props.fechaPago);
    auxFechaPago.setHours(0, 0, 0, 0);
    const auxLimiteFecha = new Date(props.limiteFecha);
    
    return fixTimeZone(auxFechaPago) <= fixTimeZone(auxLimiteFecha);
  };

  // Bloquea el pago si existe algún periodo anterior con fechaFin < fechaPago y no está liquidado
  const isBlockedByUnliquidatedPrevPeriod = () => {
    try {
      if (!props.proyeccion || !props.fechaPago) return false;

      const toLocalDateOnlyFromValue = (value) => {
        if (!value) return null;
        if (value instanceof Date) {
          return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }

        if (typeof value === "string") {
          const s = value.trim();
          const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (m) {
            return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
          }
        }

        const parsed = parseFlexibleDate(value);
        if (!parsed || isNaN(parsed.getTime())) return null;
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      };

      const pagoDateOnly = toLocalDateOnlyFromValue(props.fechaPago);
      if (!pagoDateOnly) return false;

      return props.proyeccion.some((p) => {
        if (!p?.fechaFin) return false;
        const fechaFinOnly = toLocalDateOnlyFromValue(p.fechaFin);
        if (!fechaFinOnly || fechaFinOnly.getFullYear() < 2025) return false;

        // BLOQUEA solo si la fecha de pago es estrictamente mayor al día de fin
        // Ejemplo: Pago (Feb 3) > Fin (Feb 2) -> BLOQUEA
        // Ejemplo: Pago (Feb 2) > Fin (Feb 2) -> FALSE (NO BLOQUEA)
        if (pagoDateOnly > fechaFinOnly && p.liquidado === false) {
          const formatLocalYmd = (dateObj) => {
            const y = dateObj.getFullYear();
            const m = String(dateObj.getMonth() + 1).padStart(2, "0");
            const d = String(dateObj.getDate()).padStart(2, "0");
            return `${y}-${m}-${d}`;
          };
          console.log(
            `[VALIDATE UNLIQ] Bloquea: Pago ${formatLocalYmd(pagoDateOnly)} > Fin ${formatLocalYmd(fechaFinOnly)}, Liquidado: ${p.liquidado}`
          );
          return true;
        }

        return false;
      });
    } catch (err) {
      console.error("Error evaluando periodos no liquidados:", err);
      return false;
    }
  };
  
  const handleShow = async (e) => {
    e.preventDefault();

    const actUsrToken = window.sessionStorage.getItem("localToken");

    try {
      const fechaISO = props.fechaPago.toISOString();
      const verificacionResponse = await axios.get(
        `${apiMethods.BASE_URL}/creditos/${props.id}/proyeccion/verificar?fechaPago=${fechaISO}`,
        { headers: { Authorization: actUsrToken } }
      );

      if (verificacionResponse.data.code !== 0) {
        toast.error(
          verificacionResponse.data.message || "Error al verificar pago"
        );
        return;
      }

      // Si requiere extensión, mostrar modal
      if (verificacionResponse.data.requiereExtension) {
        setState({
          showModal: true,
          emptyPayment: props.emptyPayment,
          mesesRequeridos: verificacionResponse.data.mesesNecesarios,
        });
      } else {
        // No requiere extensión, procesar pago directamente
        submitHandlerPagos(e);
      }
    } catch (error) {
      console.error("Error validando pago:", error);
      toast.error("Error al validar el pago");
    }
  };

  function formatNumber(n) {
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const closePeriod = () => {
    let body = {
      fechaIni:
        props.startDate.getFullYear() +
        "/" +
        ("0" + (props.startDate.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + props.startDate.getDate()).slice(-2),
      fechaFin:
        props.endDate.getFullYear() +
        "/" +
        ("0" + (props.endDate.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + props.endDate.getDate()).slice(-2),
    };

    Swal.fire({ title: "Cargando", allowOutsideClick: false });
    Swal.showLoading();
    axios
      .post(apiMethods.CIERRE_PERIODO, body, {})
      .then((response) => {
        Swal.close();
        toast.success(`Cierre de periodo exitoso`);
        // window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Error al cerrar el periodo");
      });
  };

  const downloadPaymentsAplication = async () => {
    const actUsrToken = window.sessionStorage.getItem("localToken");

    try {
      // Validar que se hayan seleccionado fechas
      if (!props.startDate || !props.endDate) {
        toast.error("Debe seleccionar un rango de fechas");
        return;
      }

      // Mostrar loading
      Swal.fire({
        title: "Generando PDF...",
        text: "Por favor espere",
        allowOutsideClick: false,
      });
      Swal.showLoading();

      // Formatear fechas a ISO
      const startDateISO = props.startDate.toISOString();
      const endDateISO = props.endDate.toISOString();

      console.log("[PDF] Solicitando PDF:", {
        creditoId: props.id,
        startDate: startDateISO,
        endDate: endDateISO,
      });

      // Llamar al backend para generar PDF
      const response = await axios.get(
        `${apiMethods.BASE_URL}/creditos/${props.id}/pdf/aplicacion-pagos?startDate=${startDateISO}&endDate=${endDateISO}`,
        {
          headers: { Authorization: actUsrToken },
          responseType: "blob", // Importante: recibir como blob
        }
      );

      Swal.close();

      // Crear URL del blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Crear elemento <a> para descargar
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `APLICACION_PAGOS_${props.id}.pdf`);

      // Agregar al DOM, hacer click, y remover
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Limpiar URL del blob
      window.URL.revokeObjectURL(url);

      toast.success("PDF generado exitosamente");

      
    } catch (error) {
      Swal.close();
      console.error("[PDF] ❌ Error generando PDF:", error);

      // Manejar errores específicos
      if (error.response?.status === 404) {
        toast.error("Crédito no encontrado");
      } else if (error.response?.status === 400) {
        toast.error(
          error.response.data.message ||
            "Error en los parámetros de la solicitud"
        );
      } else {
        toast.error("Error al generar el PDF. Por favor intente de nuevo.");
      }
    }
  };

  const delPago = async () => {
    let actUsrToken = window.sessionStorage.getItem("localToken");

    try {
      const response = await axios.post(
        apiMethods.DELETE_ULTIMO_PAGO + props.id,
        null,
        {
          headers: { Authorization: actUsrToken },
        }
      );

      if (response.data.code === 0) {
        toast.success("Pago eliminado exitosamente");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(response.data.message || "Error al eliminar pago");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error al eliminar pago");
    }
  };

  function buildTableBody(data, columns) {
    var body = [];

    var columnsText = [];

    columns.forEach((c) => {
      columnsText.push({ text: c, fontSize: 9, bold: true });
    });

    //body.push(columnsText);

    data.forEach(function (row) {
      var dataRow = [];

      columns.forEach(function (column) {
        dataRow.push(row[column]);
      });

      body.push(dataRow);
    });

    return body;
  }

  function table(data, columns, id) {
    if (id == "A") {
      return {
        table: {
          widths: [70, 70, 70, 70],
          alignment: "center",
          //headerRows: 1,
          body: buildTableBody(data, columns),
        },
      };
    } else if (id == "B") {
      return {
        table: {
          //headerRows: 1,
          alignment: "center",
          body: buildTableBodyB(data, columns),
          alignment: "center",
        },
      };
    } else if (id == "C") {
      return {
        table: {
          widths: [55, 55],
          alignment: "center",
          //headerRows: 1,
          body: buildTableBodyC(data, columns),
          alignment: "center",
        },
      };
    } else if (id == "D") {
      return {
        table: {
          widths: [70, 70, 70, 70],
          alignment: "center",
          //headerRows: 1,
          body: buildTableBodyD(data, columns),
          alignment: "center",
        },
      };
    } else {
      return {
        table: {
          widths: [55, 55],
          //headerRows: 1,
          body: buildTableBodyD(data, columns),
          alignment: "center",
        },
      };
    }
  }

  function buildTableBodyC(data, columns) {
    var body = [];
    var auxC = [];
    auxC.push({
      text: "CUOTA APROX. EN PESOS",
      fontSize: 9,
      bold: true,
      alignment: "center",
    });
    auxC.push({
      text: "SALDO EN PESOS",
      fontSize: 9,
      bold: true,
      alignment: "center",
    });

    //body.push(auxC);

    data.forEach(function (row) {
      var dataRow = [];

      columns.forEach(function (column) {
        dataRow.push(row[column]);
      });

      body.push(dataRow);
    });

    return body;
  }

  function buildTableBodyB(data, columns) {
    var body = [];
    var auxC = [];
    auxC.push({
      text: "NUMERO NUMERO NUMERO",
      fontSize: 9,
      color: "white",
      bold: true,
      alignment: "center",
    });

    //body.push(auxC);

    data.forEach(function (row) {
      var dataRow = [];

      columns.forEach(function (column) {
        dataRow.push(row[column]);
      });

      body.push(dataRow);
    });

    return body;
  }

  function buildTableBodyD(data, columns) {
    var body = [];

    var columnsText = [];

    columns.forEach((c) => {
      columnsText.push({
        text: c,
        fontSize: 8,
        bold: true,
        alignment: "center",
      });
    });

    body.push(columnsText);

    return body;
  }

  const toFixed = (num, fixed = 0) => {
    const n = Number(num);
    if (!Number.isFinite(n)) return 0;
    if (fixed <= 0) return Math.trunc(n);
    const f = 10 ** fixed;
    return Math.trunc(n * f) / f;
  };

  const createCredit = async (formData) => {
    // Asegurar que la proyección y sus datos actuales del componente
    // se incluyan en el payload, ya que `formik.values` puede no
    // reflejar cambios hechos directamente en `props`.
    formData.proyeccion = props.proyeccion;
    formData.proyeccionData = props.proyeccionData;

    formData.deudores = [];

    // Preparar deudores
    queryClients.forEach((client) => {
      formData.deudores.push(client.id);
    });

    if (formData.deudores.length == 0) {
      toast.warn("Debe añadir al menos un cliente");
      return;
    }

    // Convertir vlrCapital a número
    if (
      typeof formData.vlrCapital === "string" ||
      formData.vlrCapital instanceof String
    ) {
      formData.vlrCapital = parseFloat(
        formData.vlrCapital.replace(/\$|,/g, "")
      );
    }

    let actUsrToken = window.sessionStorage.getItem("localToken");

    try {
      Swal.fire({ title: "Creando crédito...", allowOutsideClick: false });
      Swal.showLoading();

      // ✅ UNA SOLA petición para crear TODO
      const response = await axios.post(
        apiMethods.CREATE_CREDITO_COMPLETO,
        formData,
        {
          headers: { Authorization: actUsrToken },
        }
      );

      Swal.close();

      if (response.data.code === 0) {
        toast.success("Crédito creado exitosamente");
        window.sessionStorage.setItem("localDocument", response.data.creditoId);

        setTimeout(() => {
          window.location.href = `/credits/${response.data.creditoId}`;
        }, 1500);
      } else if (response.data.code === 403) {
        toast.error("Código de entidad financiera se encuentra registrado");
      } else {
        toast.error(response.data.message || "Error al crear crédito");
      }
    } catch (error) {
      Swal.close();
      console.error(error);
      toast.error("Error al crear el crédito");
    }
  };

  const updateCredit = async (formData) => {
    let search = getLastItem(window.location.href);

    const camposFecha = [
      'fechaAprobacion', 
      'fechaDesembolsoReal', 
      'expiryDate', 
      'mortgageDate'
    ];
    
    camposFecha.forEach(campo => {
      if (formData[campo]) {
        const fechaNormalizada = fixTimeZone(new Date(formData[campo]));
        formData[campo] = fechaNormalizada ? fechaNormalizada.toISOString() : formData[campo];
      }
    });

    try {
      Swal.fire({ title: "Actualizando crédito...", allowOutsideClick: false });
      Swal.showLoading();

      formData.proyeccion = props.proyeccion;
      formData.proyeccionData = props.proyeccionData;
      
      const response = await axios.patch(
        apiMethods.UPDATE_CREDITO_COMPLETO + search,
        formData,
        {
          headers: {
            Authorization: window.sessionStorage.getItem("localToken"),
          },
        }
      );

      Swal.close();

      if (response.data.code === 0) {
        toast.success("Crédito actualizado exitosamente");

        setTimeout(() => {
          if (
            formData.estado === "aprobado" &&
            props.transacciones.length === 0
          ) {
            window.location.href = "/credits/"+search;
          }
          window.location.reload();
        }, 2000);
      } else if (response.data.code === 403) {
        toast.warn("Código de entidad financiera ya registrado");
      } else {
        toast.error(response.data.message || "Error al actualizar");
      }
    } catch (error) {
      Swal.close();
      console.error(error);
      toast.error("Error al actualizar el crédito");
    }
  };

  const addClientesPush = async () => {
    try {
      let clientResponse = await axios.get(
        apiMethods.GET_CLIENTE_DOCUMENTO + documentoAdd
      );
      if (clientResponse.data.code == 0) {
        let client = {
          id: clientResponse.data.client.documento,
          tipoDocumento: clientResponse.data.client.tipoDocumento,
          nombre: clientResponse.data.client.nombre,
        };
        setQueryClients([client]);
        setDocumentoAdd("");
      } else {
        toast.warn("Cliente no encontrado");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: "70%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          sx={{
              backgroundColor: 'rgb(238, 238, 238)',
              color: "black",
              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
          }}
          size="small"
          disabled={props.user?.roleId !== 1}
          style={{ marginLeft: 16 }}
          onClick={() => {
            setQueryClients(prevClients => 
              prevClients.filter(client => client.id !== params.id)
            );
          }}
        >
          Eliminar
        </Button>
      </strong>
    );
  };

  const getLastItem = (thePath) =>
    thePath.substring(thePath.lastIndexOf("/") + 1);

  const classes = useStyles();

  const clientsColumns = [
    { field: "tipoDocumento", headerName: "Tipo Documento", width: "200" },
    { field: "id", headerName: "Documento", width: "250" },
    { field: "nombre", headerName: "Nombre", width: "250" },
    {
      field: "accion",
      headerName: "Acción",
      width: "150",
      renderCell: renderDetailsButton,
    },
  ];
  // const liquidacionColumns = [
  //   { field: "periodo", headerName: "Periodo", flex: 0.14, headerClassName: "text-table-lq" },
  //   { field: "pagosRealizados", headerName: "Pagos realizados en el periodo", flex: 0.14, headerClassName: "text-table-lq" },
  //   { field: "capital", headerName: "Capital", flex: 0.14, headerClassName: "text-table-lq" },
  //   { field: "interesCorriente", headerName: "Interes Corriente", flex: 0.14, headerClassName: "text-table-lq" },
  //   { field: "interesMoratorio", headerName: "Interes Moratorio", flex: 0.14, headerClassName: "text-table-lq" },
  //   { field: "seguroVida", headerName: "Seguro de Vida", flex: 0.14, headerClassName: "text-table-lq" },
  //   { field: "seguroIcendioTdr", headerName: "Seguro de Incendio y Todo Riesgo", flex: 0.14, headerClassName: "text-table-lq" },
  // ];
  function renderTableHeaderLiquidaciones() {
    let header = [
      "Periodo",
      "Pagos realizados en el periodo",
      "Capital",
      "Interes Corriente",
      "Interés Moratorio",
      "Seguro de Vida",
      "Seguro de incendio y todo riesgo",
    ];
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  const formatterMonto = (e) => {
    if (e.target.value != "" || isNaN(e.target.value)) {
      e.target.value = parseFloat(e.target.value.replace(/,/g, ""))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  const changeHandlerProy = (e) => {
    let changeIndex = 1;

    if (props.proyeccion[0].noCuota == 0) {
      changeIndex = 0;
    }

    if (e.target.value != "") {
      // Keep a formatted string for the UI
      const formatted = parseFloat(e.target.value.replace(/,/g, ""))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    e.target.value = formatted;

    var proyeccionAuxBack = props.proyeccion;
    var proyeccionAuxD = props.proyeccionData;
    var local = proyeccionAuxD[e.target.name - changeIndex];

    // Numeric value to send to backend
    const numericValue = parseFloat(formatted.replace(/,/g, "")) || 0;

    if (e.target.id == "segVida") {
      local.segVida = formatted; // display
      proyeccionAuxBack[e.target.name - changeIndex].segVida = numericValue; // data
    } else if (e.target.id == "segTodoRiesgo") {
      local.segTodoRiesgo = formatted; // display
      proyeccionAuxBack[e.target.name - changeIndex].segTodoRiesgo = numericValue; // data
    }
    proyeccionAuxD[e.target.name - changeIndex] = local;
    setProps({
      ...props,
      proyeccionData: proyeccionAuxD,
      proyeccion: proyeccionAuxBack,
    });
    return;
  }
    // If empty value, still update to zero
    var proyeccionAuxBack = props.proyeccion;
    var proyeccionAuxD = props.proyeccionData;
    var local = proyeccionAuxD[e.target.name - changeIndex];
    if (e.target.id == "segVida") {
      local.segVida = "";
      proyeccionAuxBack[e.target.name - changeIndex].segVida = 0;
    } else if (e.target.id == "segTodoRiesgo") {
      local.segTodoRiesgo = "";
      proyeccionAuxBack[e.target.name - changeIndex].segTodoRiesgo = 0;
    }
    proyeccionAuxD[e.target.name - changeIndex] = local;
    setProps({
      ...props,
      proyeccionData: proyeccionAuxD,
      proyeccion: proyeccionAuxBack,
    });
  };

  const isBlockedProyeccion = (noCuota) => {
    // ✅ NUEVO: Verificar si el período está liquidado (cerrado)
    // Buscar el período correspondiente en la proyección
    const periodoIndex = props.proyeccionData?.findIndex(p => p.noCuota === noCuota);
    
    if (periodoIndex !== -1 && props.proyeccion && props.proyeccion[periodoIndex]) {
      const periodo = props.proyeccion[periodoIndex];
      
      // Si el período está liquidado (cerrado), bloquear los campos de seguros
      if (periodo.liquidado === true) {
        return true;
      }
    }
    
    // Mantener la validación existente por rol y fecha
    if (
      (props.user?.roleId != 1 ? false : true) &&
      validateFechaProyeccion(noCuota)
    ) {
      return true;
    }
    
    return false;
  };

  const validateFechaProyeccion = (noCuota) => {
    if (noCuota < 0) {
      let fechaProyIni = new Date(props.proyeccionData[noCuota - 1].fechaIni);

      if (fixTimeZone(fechaProyIni) <= fixTimeZone(props.fechaUltimoPago)) {
        return true;
      }

      return false;
    }
  };

  function renderTableDataProyeccion() {
    return props.proyeccionData.map((proyeccionData, index) => {
      const {
        id,
        noCuota,
        periodo,
        capital,
        interes,
        vlrCuota,
        segVida,
        segTodoRiesgo,
        blocked,
      } = proyeccionData;
      return (
        <tr key={noCuota}>
          <td>{props.proyeccion[0].noCuota == 0 ? noCuota + 1 : noCuota}</td>
          <td>{periodo}</td>
          <td>{capital}</td>
          <td>
            <Form.Control
              type="text"
              name={noCuota}
              id="segVida"
              value={segVida}
              onChange={changeHandlerProy}
              disabled={isBlockedProyeccion(noCuota)}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              name={noCuota}
              id="segTodoRiesgo"
              value={segTodoRiesgo}
              onChange={changeHandlerProy}
              disabled={isBlockedProyeccion(noCuota)}
            />
          </td>
        </tr>
      );
    });
  }

  function renderTableDataProyeccionUVR() {
    return props.proyeccionData.map((proyeccionData, index) => {
      const {
        id,
        noCuota,
        periodo,
        vlrCapitalUVR,
        vlrInteresUVR,
        vlrCuotaUVR,
        segVida,
        segTodoRiesgo,
        blocked,
      } = proyeccionData;
      return (
        <tr key={noCuota}>
          <td>{props.proyeccion[0].noCuota == 0 ? noCuota + 1 : noCuota}</td>
          <td>{periodo}</td>
          <td>{vlrCapitalUVR}</td>
          <td>
            <Form.Control
              type="text"
              name={noCuota}
              id="segVida"
              value={segVida}
              onChange={changeHandlerProy}
              disabled={isBlockedProyeccion(noCuota)}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              name={noCuota}
              id="segTodoRiesgo"
              value={segTodoRiesgo}
              onChange={changeHandlerProy}
              disabled={isBlockedProyeccion(noCuota)}
            />
          </td>
        </tr>
      );
    });
  }

  function parsedDate(date) {
    
    const d = new Date(date);

    const year = d.getUTCFullYear();
    let month = d.getUTCMonth() + 1;
    let day = d.getUTCDate();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;

    return `${day}-${month}-${year}`;
  }

  const auxDetailUVR = async (e) => {
      e.preventDefault();
      
      // Obtener la fila clickeada
      let target = e.target;
      while (target && target.nodeName !== "TR") {
        target = target.parentNode;
      }
  
      if (!target) return;
  
      // Configurar formateador de números
      const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 0,
      });
  
      const hiddenElement = target.nextSibling;
  
      // Toggle del elemento colapsable
      if (hiddenElement.classList.contains("show")) {
        hiddenElement.classList.remove("show");
      } else {
        hiddenElement.classList.add("show");
      }
  
      // Obtener índice del periodo
      const periodo = target.cells[0].childNodes[0].data;
      const indexOf = props.liquidacionesData.findIndex(i => i.periodo === periodo) - 1;
  
      if (indexOf < 0) return;
      
      // LOGS DIAGNÓSTICOS: registrar tamaños y valores clave para depuración
      console.debug('[auxDetailUVR] periodo:', periodo);
      console.debug('[auxDetailUVR] indexOf:', indexOf);
      console.debug('[auxDetailUVR] pagosPorCreditos length:', props.pagosPorCreditos?.length);
      console.debug('[auxDetailUVR] transaccionesData length:', props.transaccionesData?.length);
      console.debug('[auxDetailUVR] detalleData length:', props.detalleData?.length);
      console.debug('[auxDetailUVR] detalleDataUVR length:', props.detalleDataUVR?.length);
  
      // Buscar el último pago válido
      let lookForPago = indexOf;
      while (lookForPago >= 0 && props.transaccionesData[lookForPago] == 0) {
        lookForPago--;
      }
  
      // Contadores
      let cntCuotaPaga = 0;
      let sumExtra = 0;
      let cntPagosCuotas = 0;
  
      // Calcular cuotas pagas y extras
      for (let i = 0; i < indexOf; i++) {
        const pago = props.pagosPorCreditos[i];
        if (pago != 0) {
          cntCuotaPaga += pago;
          cntPagosCuotas++;
          if (pago > 1) {
            sumExtra += pago - 1;
          }
        }
      }
  
      // Calcular lapsos de mora
      let cntLapMora = 0;
      let paga = false;
      for (let i = 0; i <= indexOf; i++) {
        if (props.pagosPorCreditos[i] == 0) {
          paga = false;
        } else {
          if (!paga) {
            cntLapMora++;
          }
          paga = true;
        }
      }
  
      const cntPagos = props.pagosPorCreditos[lookForPago];
      let cntPagData = cntPagos - 1;
  
      const btnRefIndex = parseInt(e.currentTarget.id) - 1 + 
                          (props.pagosPorCreditos[indexOf] - 1) + 
                          sumExtra - 2000;

      console.debug('[auxDetailUVR] lookForPago:', lookForPago, 'cntPagos:', cntPagos, 'cntPagData:', cntPagData, 'btnRefIndex:', btnRefIndex);
  
      // Generar información de pagos
      const childNodes = target.nextSibling.cells[0].childNodes[0].childNodes;
  
      // Obtener valor UVR actual
      const uvrDate = parsedDate(props.transacciones[cntCuotaPaga].fechaTx);
      let vlrUVRActual;
      console.log("UVR Date:", uvrDate);
  
      try {
        const actUsrToken = window.sessionStorage.getItem("localToken");
        const response = await axios.get(apiMethods.GET_UVR_FECHA + uvrDate , {
          headers: {
            Authorization: actUsrToken,
          }
        });
  
        if (response.data?.uvr?.[0]?.valor) {
          vlrUVRActual = response.data.uvr[0].valor;
        }
      } catch (error) {
        console.error("Error obteniendo valor UVR:", error);
      }
  
      console.log("Valor UVR Actual:", vlrUVRActual);
  
      if (cntPagos > 1) {
        let cntPago = 0;
        let tempCntPagData = cntPagData;
  
        for (let i = 0; i < cntPagos * 2; i += 2) {
          const transaccion = props.transaccionesData[btnRefIndex - tempCntPagData];
          childNodes[i].innerHTML = 
            `<b>Pago ${cntPago + 1}</b>: <span>${formatter.format(toFixed(transaccion.vlrTxUVR, 2))} UVR</span> (<span style='color: #0059e6'>$${transaccion.vlrTx}</span>) el <strong>${transaccion.fechaTx}</strong>. (Valor UVR: ${vlrUVRActual})`;
          cntPago++;
          tempCntPagData--;
        }
      } else {
        const transaccion = props.transaccionesData[cntCuotaPaga];
        childNodes[0].innerHTML = 
          `<b>Pago 1</b>: <span>${formatter.format(toFixed(transaccion.vlrTxUVR, 2))} UVR</span> (<span style='color: #0059e6'>$${transaccion.vlrTx}</span>) el <strong>${transaccion.fechaTx}</strong>. (Valor UVR: ${vlrUVRActual})`;
      }
  
      // Obtener dimensiones de las columnas
      const dimensions = [];
      for (let i = 2; i < target.cells.length; i++) {
        dimensions.push(target.cells[i].offsetWidth);
      }
  
      const auxDimensions = target.cells[0].offsetWidth + target.cells[1].offsetWidth;
  
      // Generar tablas de detalle
      const tables = [];
      cntPagData = cntPagos - 1;
  
      for (let h = 0; h < props.pagosPorCreditos[indexOf]; h++) {
        let HTML = "<table border=1 width=100%>";
  
        // Saldo Inicial
        HTML += "<tr>";
        HTML += `<td style="width:${auxDimensions}px">Saldo Inicial</td>`;
        for (let j = 1; j <= 5; j++) {
          const valorUVR = props.detalleDataUVR[btnRefIndex - cntPagData][0][j - 1];
          
          let valorPesosTexto;
          if (j === 4 || j === 5) {
            // Seguros: usar valor en pesos directo de detalleData
            valorPesosTexto = props.detalleData[btnRefIndex - cntPagData][0][j - 1];
          } else {
            // Capital e intereses: convertir UVR a pesos
            const valorPesos = parseFloat(valorUVR.replace(",", "")) * vlrUVRActual;
            valorPesosTexto = valorPesos.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
          
          HTML += `<td style="width:${dimensions[j - 1]}px">${valorUVR} UVR<p style='color: #0059e6 !important'>($${valorPesosTexto})</p></td>`;
        }
        HTML += "</tr>";
        
        // Movimientos
        HTML += "<tr>";
        HTML += `<td style="width:${auxDimensions}px">Movimientos</td>`;
        HTML += "<td></td>";
        for (let j = 1; j <= 4; j++) {
          const valorUVR = props.detalleDataUVR[btnRefIndex - cntPagData][1][j - 1];
          const valorPesos = props.detalleData[btnRefIndex - cntPagData][1][j - 1];
          HTML += `<td style="width:${dimensions[j]}px">${valorUVR} UVR<p style='color: #0059e6 !important'>($${valorPesos})</p></td>`;
        }
        HTML += "</tr>";
  
        // Aplicación del pago
        HTML += "<tr>";
        HTML += "<td>Aplicación del pago</td>";
        for (let j = 1; j <= 5; j++) {
          const valorUVR = props.detalleDataUVR[btnRefIndex - cntPagData][2][j - 1];
          const valorPesos = props.detalleData[btnRefIndex - cntPagData][2][j - 1];
          HTML += `<td>${valorUVR} UVR<p style='color: #0059e6 !important'>($${valorPesos.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p></td>`;
        }
        HTML += "</tr>";
  
        // Nuevo Saldo
        HTML += "<tr>";
        HTML += "<td>Nuevo Saldo</td>";
        for (let j = 1; j <= 5; j++) {
          const valorUVR = props.detalleDataUVR[btnRefIndex - cntPagData][3][j - 1];
          const valorPesos = props.detalleData[btnRefIndex - cntPagData][3][j - 1];
          HTML += `<td>${valorUVR} UVR<p style='color: #0059e6 !important'>($${valorPesos})</p></td>`;
        }
        HTML += "</tr>";
  
        HTML += "</table>";
        tables.push(HTML);
        cntPagData--;
      }
  
      // Remover primera fila de tablas secundarias
      if (props.pagosPorCreditos[indexOf] > 1) {
        for (let p = 1; p < props.pagosPorCreditos[indexOf]; p++) {
          const auxString = tables[p];
          const part1 = auxString.substring(0, auxString.indexOf("<tr>"));
          const part2 = auxString.substring(auxString.indexOf("</tr>"), auxString.length);
          tables[p] = part1 + part2;
        }
      }
  
      // --- TABLA DE RESUMEN UVR (Formato exacto y medidas iguales) ---
      const datosUVR = props.liquidacionesDataUVR.find(liq => liq.periodo === periodo);
      const datosPesos = props.liquidacionesData.find(liq => liq.periodo === periodo);

      let HTML = "<table border=1 width=100%>";
      
      // Fila: Resultado del periodo
      HTML += "<tr>";
      HTML += `<td style="width:${auxDimensions}px">Resultado del periodo</td>`;
      HTML += `<td style="width:${dimensions[0]}px"></td>`; // Columna Saldo vacía
      HTML += `<td style="width:${dimensions[1]}px">${datosUVR?.interesCorriente || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.interesCorriente || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[2]}px">${datosUVR?.interesMoratorio || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.interesMoratorio || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[3]}px">${datosUVR?.segVida || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.segVida || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[4]}px">${datosUVR?.segTodoRiesgo || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.segTodoRiesgo || 0})</p></td>`;  
      HTML += "</tr>";

      // Fila: Nuevo Saldo
      HTML += "<tr>";
      HTML += `<td style="width:${auxDimensions}px">Nuevo Saldo</td>`;
      HTML += `<td style="width:${dimensions[0]}px">${datosUVR?.capital || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.capital || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[1]}px">${datosUVR?.interesCorriente || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.interesCorriente || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[2]}px">${datosUVR?.interesMoratorio || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.interesMoratorio || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[3]}px">${datosUVR?.segVida || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.segVida || 0})</p></td>`;
      HTML += `<td style="width:${dimensions[4]}px">${datosUVR?.segTodoRiesgo || 0} UVR<p style='color: #0059e6 !important; margin:0;'>($${datosPesos?.segTodoRiesgo || 0})</p></td>`;
      HTML += "</tr>";
      
      HTML += "</table>";
      
      tables.push(HTML);
  
      // Insertar tablas en el DOM
      let tableIndex = 0;
      let p = 1;
  
      for (p = 1; p < cntPagos * 2; p += 2) {
        childNodes[p].innerHTML = tables[tableIndex];
        tableIndex++;
      }
  
      childNodes[p].innerHTML = tables[tables.length - 1];
  
      // Toggle del icono +/-
      const iconElement = document.getElementById(target.cells[0].childNodes[2].id);
      if (iconElement) {
        iconElement.innerHTML = iconElement.innerHTML === "-" ? "+" : "-";
      }
    };

  const auxDetail = (e) => {
    e.preventDefault();

    let target = e.target;
    while (target && target.nodeName !== "TR") {
      target = target.parentNode;
    }

    if (!target) return;

    const formatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0,
    });

    const hiddenElement = target.nextSibling;

    if (hiddenElement.classList.contains("show")) {
      hiddenElement.classList.remove("show");
    } else {
      hiddenElement.classList.add("show");
    }

    const periodo = target.cells[0].childNodes[0].data;
    const indexOf = props.liquidacionesData.findIndex(i => i.periodo === periodo) - 1;

    if (indexOf < 0) return;

    // Funciones de parseo
    const parseFechaPeriodo = (str) => {
      const meses = {
        'ENE': 0, 'FEB': 1, 'MAR': 2, 'ABR': 3, 'MAY': 4, 'JUN': 5,
        'JUL': 6, 'AGO': 7, 'SEP': 8, 'OCT': 9, 'NOV': 10, 'DIC': 11,
        'JAN': 0, 'FEB': 1, 'MAR': 2, 'APR': 3, 'MAY': 4, 'JUN': 5,
        'JUL': 6, 'AUG': 7, 'SEP': 8, 'OCT': 9, 'NOV': 10, 'DEC': 11
      };
      
      const limpio = str.trim().replace(/\s+de\s+/g, ' ');
      const partes = limpio.split(' ');
      
      const dia = parseInt(partes[0]);
      const mes = meses[partes[1]?.toUpperCase()];
      const año = parseInt(partes[2]);
      
      if (mes === undefined) return null;
      return new Date(año, mes, dia);
    };

    const parseFechaMovimiento = (str) => {
      const meses = {
        'ENE': 0, 'FEB': 1, 'MAR': 2, 'ABR': 3, 'MAY': 4, 'JUN': 5,
        'JUL': 6, 'AGO': 7, 'SEP': 8, 'OCT': 9, 'NOV': 10, 'DIC': 11,
        'JAN': 0, 'FEB': 1, 'MAR': 2, 'APR': 3, 'MAY': 4, 'JUN': 5,
        'JUL': 6, 'AUG': 7, 'SEP': 8, 'OCT': 9, 'NOV': 10, 'DEC': 11
      };
      
      const partes = str.split('-');
      const dia = parseInt(partes[0]);
      const mes = meses[partes[1]?.toUpperCase()];
      const año = parseInt(partes[2]);
      
      if (mes === undefined) return null;
      return new Date(año, mes, dia);
    };

    const [fechaInicioStr, fechaFinStr] = periodo.split(' al ');
    const fechaInicio = parseFechaPeriodo(fechaInicioStr);
    const fechaFin = parseFechaPeriodo(fechaFinStr);

    if (!fechaInicio || !fechaFin) {
      console.error('Error parseando período:', periodo);
      const childNodes = target.nextSibling.cells[0].childNodes[0].childNodes;
      if (childNodes[0]) childNodes[0].innerHTML = "<b>Error: formato de fecha no válido</b>";
      return;
    }

    console.group(`PERIODO: ${periodo}`);
    console.log('Rango válido:', fechaInicio.toLocaleDateString(), 'a', fechaFin.toLocaleDateString());

    // FILTRAR TODAS LAS TRANSACCIONES POR FECHA (no usar pagosPorCreditos)
    const indices = [];
    const movimientosEnPeriodo = (props.transaccionesData || []).filter((tx, idx) => {
      const monto = parseFloat(tx.vlrTx.toString().replace(/,/g, ''));
      const fechaMov = parseFechaMovimiento(tx.fechaTx);
      
      if (!fechaMov) return false;
      
      const tienePago = monto >= 0;
      const estaEnRango = fechaMov >= fechaInicio && fechaMov <= fechaFin;
      
      if (tienePago && estaEnRango) {
        indices.push(idx);
        console.log(`Incluido: ${tx.fechaTx} - $${monto.toLocaleString()}`);
        return true;
      }
      return false;
    });

    const detalleEnPeriodo = indices.map(i => props.detalleData[i]);

    console.log('Movimientos válidos:', movimientosEnPeriodo.length);
    console.groupEnd();

    const childNodes = target.nextSibling.cells[0].childNodes[0].childNodes;

    // Limpiar labels previos
    for (let i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeName === "B" || childNodes[i].nodeName === "SPAN") {
        childNodes[i].innerHTML = "";
      }
    }

    // Mostrar solo movimientos válidos
    if (movimientosEnPeriodo.length > 0) {
      movimientosEnPeriodo.forEach((tx, i) => {
        if (childNodes[i * 2]) {
          const monto = parseFloat(tx.vlrTx.toString().replace(/,/g, '')).toLocaleString();
          childNodes[i * 2].innerHTML = 
            `<b>Movimiento ${i + 1}</b>: <span style='color: #0059e6'>$${monto}</span> el <strong>${tx.fechaTx}</strong>`;
        }
      });
    } else {
      if (childNodes[0]) childNodes[0].innerHTML = "<b>No se registraron pagos en este período</b>";
    }

    // Obtener dimensiones
    const dimensions = [];
    for (let i = 2; i < target.cells.length; i++) {
      dimensions.push(target.cells[i].offsetWidth);
    }
    const auxDimensions = target.cells[0].offsetWidth + target.cells[1].offsetWidth;

    // Si no hay movimientos válidos, mostrar solo resumen
    if (detalleEnPeriodo.length === 0) {
      console.log('No hay movimientos con pago en este período');
      
      // Calcular índice de resumen
      const totalMovimientosPrevios = props.pagosPorCreditos
          .slice(0, indexOf)
          .reduce((a, b) => a + (Number(b) || 0), 0);
      const movimientosEsteMes = Number(props.pagosPorCreditos[indexOf]) || 0;
      const indiceResumen = totalMovimientosPrevios + movimientosEsteMes - 1;
      
      let HTML = "<table border=1 width=100%>";
      HTML += "<tr>";
      HTML += "<td>Resultado del periodo</td>";
      HTML += "<td></td>";
      for (let j = 1; j <= 4; j++) {
        HTML += `<td>${props.resPeriodo[indiceResumen]?.[j] || 0}</td>`;
      }
      HTML += "</tr>";
      HTML += "<tr>";
      HTML += `<td style="width:${auxDimensions}px">Nuevo Saldo</td>`;
      for (let j = 0; j <= 4; j++) {
        HTML += `<td style="width:${dimensions[j]}px">${props.resPeriodo[indiceResumen]?.[j] || 0}</td>`;
      }
      HTML += "</tr>";
      HTML += "</table>";
      
      if (childNodes[1]) {
        childNodes[1].innerHTML = HTML;
      }
      
      // Toggle icono
      const iconElement = document.getElementById(target.cells[0].childNodes[2].id);
      if (iconElement) {
        iconElement.innerHTML = iconElement.innerHTML === "-" ? "+" : "-";
      }
      
      return;
    }

    // Generar tablas para cada movimiento
    const tables = [];

    for (let h = 0; h < detalleEnPeriodo.length; h++) {
      let HTML = "<table border=1 width=100%>";

      // Saldo Inicial
      HTML += "<tr>";
      HTML += `<td style="width:${auxDimensions}px">Saldo Inicial</td>`;
      for (let j = 1; j <= 5; j++) {
        HTML += `<td style="width:${dimensions[j - 1]}px">${detalleEnPeriodo[h][0][j - 1]}</td>`;
      }
      HTML += "</tr>";

      // Movimientos
      HTML += "<tr>";
      HTML += `<td style="width:${auxDimensions}px">Movimientos</td>`;
      HTML += "<td></td>";
      for (let j = 1; j <= 4; j++) {
        HTML += `<td style="width:${dimensions[j]}px">${detalleEnPeriodo[h][1][j - 1]}</td>`;
      }
      HTML += "</tr>";

      // Aplicación del pago
      HTML += "<tr>";
      HTML += "<td>Aplicación del pago</td>";
      for (let j = 1; j <= 5; j++) {
        const valor = detalleEnPeriodo[h][2][j - 1];
        const valorFormateado = typeof valor === 'number' 
          ? valor.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : valor;
        HTML += `<td>${valorFormateado}</td>`;
      }
      HTML += "</tr>";

      // Nuevo Saldo
      HTML += "<tr>";
      HTML += "<td>Nuevo Saldo</td>";
      for (let j = 1; j <= 5; j++) {
        HTML += `<td>${detalleEnPeriodo[h][3][j - 1]}</td>`;
      }
      HTML += "</tr>";

      HTML += "</table>";
      tables.push(HTML);
    }

    // Remover primera fila de tablas secundarias
    if (detalleEnPeriodo.length > 1) {
      for (let p = 1; p < detalleEnPeriodo.length; p++) {
        const auxString = tables[p];
        const part1 = auxString.substring(0, auxString.indexOf("<tr>"));
        const part2 = auxString.substring(auxString.indexOf("</tr>"), auxString.length);
        tables[p] = part1 + part2;
      }
    }

    // Tabla de resumen del periodo
    const datosMes = props.liquidacionesData.find(liq => liq.periodo === periodo);

    let HTML = "<table border=1 width=100%>";
    
    // Fila: Resultado del periodo
    HTML += "<tr>";
    HTML += `<td style="width:${auxDimensions}px">Resultado del periodo</td>`;
    HTML += `<td style="width:${dimensions[0]}px"></td>`; // Columna Saldo (vacia)
    HTML += `<td style="width:${dimensions[1]}px">${datosMes?.interesCorriente || 0}</td>`;
    HTML += `<td style="width:${dimensions[2]}px">${datosMes?.interesMoratorio || 0}</td>`;
    HTML += `<td style="width:${dimensions[3]}px">${datosMes?.segVida || 0}</td>`;
    HTML += "</tr>";

    // Fila: Nuevo Saldo
    HTML += "<tr>";
    HTML += `<td style="width:${auxDimensions}px">Nuevo Saldo</td>`;
    HTML += `<td style="width:${dimensions[0]}px">${datosMes?.capital || 0}</td>`;
    HTML += `<td style="width:${dimensions[1]}px">${datosMes?.interesCorriente || 0}</td>`;
    HTML += `<td style="width:${dimensions[2]}px">${datosMes?.interesMoratorio || 0}</td>`;
    HTML += `<td style="width:${dimensions[3]}px">${datosMes?.segVida || 0}</td>`;
    HTML += `<td style="width:${dimensions[4]}px">${datosMes?.segTodoRiesgo || 0}</td>`;
    HTML += "</tr>";
    
    HTML += "</table>";
    
    tables.push(HTML);

    // Insertar tablas en el DOM
    let tableIndex = 0;
    let p = 1;

    for (p = 1; p < movimientosEnPeriodo.length * 2; p += 2) {
      childNodes[p].innerHTML = tables[tableIndex];
      tableIndex++;
    }

    childNodes[p].innerHTML = tables[tables.length - 1];

    // Toggle del icono +/-
    const iconElement = document.getElementById(target.cells[0].childNodes[2].id);
    if (iconElement) {
      iconElement.innerHTML = iconElement.innerHTML === "-" ? "+" : "-";
    }
  };

  function renderTableDataLiquidaciones() {
    return props.liquidacionesData.map((liquidacionesData, index) => {
      const {
        id,
        periodo,
        pagosTotal,
        capital,
        interesCorriente,
        interesMoratorio,
        segVida,
        segTodoRiesgo,
      } = liquidacionesData;
      if (index == 0 || props.pagosPorCreditos[index - 1] == 0) {
        return (
          <tr key={id}>
            <td>{periodo}</td>
            <td>{pagosTotal}</td>
            <td>{capital}</td>
            <td>{interesCorriente}</td>
            <td>{interesMoratorio}</td>
            <td>{segVida}</td>
            <td>{segTodoRiesgo}</td>
          </tr>
        );
      } else {
        return (
          <React.Fragment>
            <tr key={id}>
              <td>
                {periodo}{" "}
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    maxWidth: "15px",
                    maxHeight: "20px",
                    minWidth: "15px",
                    minHeight: "20px",
                  }}
                  id={props.iteradorPagos[index - 1] + 1000}
                  onClick={auxDetail}>
                  +
                </Button>
              </td>
              <td>{pagosTotal}</td>
              <td>{capital}</td>
              <td>{interesCorriente}</td>
              <td>{interesMoratorio}</td>
              <td>{segVida}</td>
              <td>{segTodoRiesgo}</td>
            </tr>
            <tr className="collapse">
              <td colSpan="7">
                <div className="formTitleDetail">
                  {new Array(props.pagosPorCreditos[index - 1]).fill(
                    <React.Fragment>
                      <Form.Label id={index}></Form.Label>
                      <table id="table">
                        <tbody></tbody>
                      </table>
                    </React.Fragment>
                  )}
                  <Form.Label>Resultado del periodo</Form.Label>
                  <table id="table">
                    <tbody></tbody>
                  </table>
                </div>
              </td>
            </tr>
          </React.Fragment>
        );
      }
    });
  }

  function renderTableDataLiquidacionesUVR() {
    return props.liquidacionesDataUVR.map((liquidacionesDataUVR, index) => {
      const {
        id,
        periodo,
        pagosTotal,
        capital,
        interesCorriente,
        interesMoratorio,
        segVida,
        segTodoRiesgo,
      } = liquidacionesDataUVR;
      if (index == 0 || props.pagosPorCreditos[index - 1] == 0) {
        return (
          <tr key={id}>
            <td key={index}>{periodo}</td>
            <td key={index + 1}>
              {pagosTotal +
                " UVR" +
                " ($" +
                props.liquidacionesData[index].pagosTotal +
                ")"}
            </td>
            <td key={index + 2}>
              {capital +
                " UVR" +
                " ($" +
                props.liquidacionesData[index].capital +
                ")"}
            </td>
            <td key={index + 3}>
              {interesCorriente +
                " UVR" +
                " ($" +
                props.liquidacionesData[index].interesCorriente +
                ")"}
            </td>
            <td key={index + 4}>
              {interesMoratorio +
                " UVR" +
                " ($" +
                props.liquidacionesData[index].interesMoratorio +
                ")"}
            </td>
            <td key={index + 5}>
              {segVida +
                " UVR" +
                " ($" +
                props.liquidacionesData[index].segVida +
                ")"}
            </td>
            <td key={index + 6}>
              {segTodoRiesgo +
                " UVR" +
                " ($" +
                props.liquidacionesData[index].segTodoRiesgo +
                ")"}
            </td>
          </tr>
        );
      } else {
        return (
          <React.Fragment>
            <tr key={id}>
              <td>
                {periodo}{" "}
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    maxWidth: "15px",
                    maxHeight: "20px",
                    minWidth: "15px",
                    minHeight: "20px",
                  }}
                  id={props.iteradorPagos[index - 1] + 2000}
                  onClick={auxDetailUVR}
                >
                  +
                </Button>
              </td>
              <td>
                <p>{pagosTotal + " UVR"}</p>
                <p style={{ color: "#0059e6" }}>
                  {"($"}
                  {props.liquidacionesData[index].pagosTotal}
                  {")"}
                </p>
              </td>
              <td>
                <p>{capital + " UVR"}</p>
                <p style={{ color: "#0059e6" }}>
                  {"($"}
                  {props.liquidacionesData[index].capital}
                  {")"}
                </p>
              </td>
              <td>
                <p>{interesCorriente + " UVR"}</p>
                <p style={{ color: "#0059e6" }}>
                  {"($"}
                  {props.liquidacionesData[index].interesCorriente}
                  {")"}
                </p>
              </td>
              <td>
                <p>{interesMoratorio + " UVR"}</p>
                <p style={{ color: "#0059e6" }}>
                  {"($"}
                  {props.liquidacionesData[index].interesMoratorio}
                  {")"}
                </p>
              </td>
              <td>
                <p>{segVida + " UVR"}</p>
                <p style={{ color: "#0059e6" }}>
                  {"($"}
                  {props.liquidacionesData[index].segVida}
                  {")"}
                </p>
              </td>
              <td>
                <p>{segTodoRiesgo + " UVR"}</p>
                <p style={{ color: "#0059e6" }}>
                  {"($"}
                  {props.liquidacionesData[index].segTodoRiesgo}
                  {")"}
                </p>
              </td>
            </tr>
            <tr className="collapse">
              <td colSpan="7">
                <div className="formTitleDetail">
                  {new Array(props.pagosPorCreditos[index - 1]).fill(
                    <React.Fragment>
                      <Form.Label id={index}></Form.Label>
                      <table id="table">
                        <tbody></tbody>
                      </table>
                    </React.Fragment>
                  )}
                  <Form.Label>Resultado del periodo</Form.Label>
                  <table id="table">
                    <tbody></tbody>
                  </table>
                </div>
              </td>
            </tr>
          </React.Fragment>
        );
      }
    });
  }

  function renderTableHeaderTransacciones() {
    let header = ["ID", "Monto", "Fecha Pago", "Acción"];
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  function renderTableDataTransacciones(transacciones) {
    return transacciones.map((transaccionesData, index) => {
      const { id, vlrTx, fechaTx } = transaccionesData;
      if (id == props.transaccionesData.length - 1) {
        return (
          <tr key={id}>
            <td>{id}</td>
            <td>{formatter.format(vlrTx)}</td>
            <td>{formatDate(fechaTx)}</td>
            <td>
              <Button
                style={{ 
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "none"
                }}
                onClick={handleShowDeletePayment}
                disabled={isDeleteBlocked(fechaTx)}
              >
                Eliminar
              </Button>
            </td>
          </tr>
        );
      } else {
        return (
          <tr key={id}>
            <td>{id}</td>
            <td>{formatter.format(vlrTx)}</td>
            <td>{formatDate(fechaTx)}</td>
            <td></td>
          </tr>
        );
      }
    });
  }

  const renderTableDataYear = () => {
    return props.paymentYears.map((fechaTx, index) => {
      return (
        <tr key={fechaTx}>
          <Accordion className="acordeon">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>
                <div style={{ marginLeft: "1rem" }} className="acordeon-text">
                  {fechaTx}
                </div>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <div style={{ width: "100%", margin: "1rem 0 2rem 0" }}>
                  {props.paymentsPerYear[index].length > 0 ? (
                    <table
                      id="table"
                      className="table table-hover bg-white table-striped"
                    >
                      <tbody>
                        <tr>{renderTableHeaderTransacciones()}</tr>
                        {renderTableDataTransacciones(
                          props.paymentsPerYear[index]
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div>No se registran pagos</div>
                  )}
                </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
          <br></br>
        </tr>
      );
    });
  };

  const formatDate = (date) => {
    return (
      ("0" + fixTimeZone(new Date(date)).getDate()).slice(-2) +
      "-" +
      months[fixTimeZone(new Date(date)).getMonth()] +
      "-" +
      fixTimeZone(new Date(date)).getFullYear()
    );
  };

  function renderTableHeaderProyeccion() {
    let header = [
      "No. Cuota",
      "Periodo",
      "Capital",
      "Seguro de vida",
      "Seguro de incendio y todo riesgo",
    ];
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  function renderTableDataTransaccionesLess() {
    return props.transaccionesData.map((transaccionesData, index) => {
      const { id, vlrTx, fechaTx } = transaccionesData;
      return (
        <tr key={id}>
          <td>{id}</td>
          <td>{vlrTx}</td>
          <td>{fechaTx}</td>
        </tr>
      );
    });
  }

  const showProy = (e) => {
    e.preventDefault();
    if (props.proyState === 1) {
      document.getElementById("proyTable").style.display = "none";
      document.getElementById("showProy").innerHTML = "Mostrar Proyección";
      setProps({ ...props, proyState: 0 });
    } else {
      document.getElementById("proyTable").style.display = "block";
      document.getElementById("showProy").innerHTML = "Ocultar Proyección";
      setProps({ ...props, proyState: 1 });
    }
  };

  const addCuota = async (e) => {
    e.preventDefault();

    let actUsrToken = window.sessionStorage.getItem("localToken");
    const creditId = getLastItem(window.location.href);

    try {
      const response = await axios.post(
        apiMethods.AGREGAR_CUOTA + creditId,
        null,
        {
          headers: { Authorization: actUsrToken },
        }
      );

      if (response.data.code === 0) {
        toast.success("Cuota agregada exitosamente");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(response.data.message || "Error al agregar cuota");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error al agregar la cuota");
    }
  };

  const uploadFile = (event) => {
    const data = new FormData();
    data.append("file", event.target.files[0]);
    axios
      .post(apiMethods.UPLOAD_FILE_ID + props.originalId, data)
      .then((res) => {
        let files = [...props.files];
        files.push({
          id: res.data.id,
          name: res.data.name,
        });
        setState({ files: files });
      });
  };

  const parseDate = (dateValue) => {
    if (!dateValue) return null;
    
    // Si es una fecha en formato YYYY-MM-DD (string), parsearla como fecha local
    if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
      const [year, month, day] = dateValue.split('T')[0].split('-');
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? null : date;
    }
    
    // Para otros formatos, usar el constructor normal
    const date = new Date(dateValue);
    return isNaN(date.getTime()) ? null : date;
  };
  
  // Helper para formatear fechas evitando problemas de timezone
  const formatDateLocal = (dateValue, locale = 'es-CO') => {
    if (!dateValue) return '';
    
    // Si es string en formato YYYY-MM-DD, parsearlo como local
    if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
      const [year, month, day] = dateValue.split('T')[0].split('-');
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString(locale);
    }
    
    // Para Date objects o otros formatos
    const date = new Date(dateValue);
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString(locale);
  };
  
  const DatePickerState = ({ onClick }) => (
    <Button
    className="react-datepicker-ignore-onclickoutside"
    onClick={onClick}
    id="datePicker"
  >
    <TodayIcon style={{ fontSize: 24 }} />
  </Button>
  );

  const pagoBlockedByPrev = isBlockedByUnliquidatedPrevPeriod();

  return window.sessionStorage.getItem("localToken") ? (
    <React.Fragment>
      <ToastContainer />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
          <Sidebar />
          <div>
            <div className="card" style={{ width: "100%" }}>
              <div
                style={{
                  fontSize: "15pt",
                  fontWeight: "500",
                  marginBottom: "1rem",
                  marginTop: "1rem",
                  marginLeft: "1rem",
                }}
              >
                {props.exists ? "Detalle Crédito" : "Registro Crédito"}
              </div>
              {props.user?.roleId == 1 && (
                <div
                  style={{
                    width: "50%",
                    display: "grid",
                    gridTemplateColumns: "50% auto",
                    marginBottom: "2rem",
                  }}
                >
                  <TextField
                    required
                    label="Documento del cliente"
                    value={documentoAdd}
                    onChange={handleChangeDocumento}
                  />
                  <Button
                    variant="contained"
                    onClick={addClientesPush}
                    style={{
                      width: "11rem",
                      height: "2.5rem",
                      marginLeft: "2rem",
                    }}
                    sx={{
                        backgroundColor: 'rgb(238, 238, 238)',
                        color: "black",
                        '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                    }}
                  >
                    Agregar cliente
                  </Button>
                </div>
              )}
              <form
                onSubmit={(e) => {
                  formik.isValid ? submitHandler(e) : onError(e);
                }}
              >
                <div
                  style={{
                    height: 200,
                    width: "100%",
                    margin: "1rem 0 2rem 0",
                  }}
                >
                  <DataGrid
                    rows={queryClients}
                    columns={clientsColumns}
                    pageSize={15}
                    disableSelectionOnClick
                  />
                </div>
                <div
                  style={{ display: "grid", gridTemplateColumns: "auto auto" }}
                >
                  <div className="create-credit-input-row">
                    <TextField
                      disabled={props.user?.roleId == 1 ? false : true}
                      required
                      className="create-credit-input"
                      label="Código entidad financiera"
                      id="financialCode"
                      value={formik.values.financialCode}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <NumericFormat 
                      disabled={props.user?.roleId == 1 ? false : true}
                      customInput={TextField}
                      id={props.exists ? "vlrInicial" : "vlrCapital"}
                      value={
                        props.exists
                          ? formik.values.vlrInicial
                          : formik.values.vlrCapital
                      }
                      onValueChange={(values) => {
                        const fieldName = props.exists
                          ? "vlrInicial"
                          : "vlrCapital";
                        formik.setFieldValue(fieldName, values.value);
                      }}
                      label="Monto"
                      className="create-credit-input"
                      required
                      thousandSeparator={true}
                      prefix={"$"}
                      // ✅ Agregar esto para que el label siempre esté arriba
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      disabled={props.user?.roleId == 1 ? false : true}
                      required
                      className="create-credit-input"
                      label="Plazo"
                      type="number"
                      id="plazo"
                      value={formik.values.plazo}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <FormControl className={classes.formControl} style={{ width: "70%" }}>
                      <InputLabel>Moneda</InputLabel>
                      <Select
                        label="Moneda"
                        disabled={props.user?.roleId == 1 ? false : true}
                        required
                        id="moneda"
                        style={{ textAlign: "left" }}
                        name="moneda"
                        value={formik.values.moneda}
                        onChange={formik.handleChange}
                      >
                        <MenuItem value="pesos">Pesos</MenuItem>
                        <MenuItem value="uvr">UVR</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="create-credit-input-row">
                    <FormControl className={classes.formControl} style={{ width: "70%" }}>
                      <InputLabel>Garantía</InputLabel>
                      <Select
                        label="Garantía"
                        disabled={props.user?.roleId == 1 ? false : true}
                        required
                        id="garantia"
                        style={{ textAlign: "left" }}
                        name="garantia"
                        value={formik.values.garantia}
                        onChange={formik.handleChange}
                      >
                        <MenuItem value="libranza">Libranza</MenuItem>
                        <MenuItem value="hipoteca">Hipoteca</MenuItem>
                        <MenuItem value="soloPagare">Solo pagaré</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="create-credit-input-row">
                    <FormControl className={classes.formControl} style={{ width: "70%" }}>
                      <InputLabel>Tipo de amortización</InputLabel>
                      <Select
                        label="Tipo de amortización"
                        disabled={props.user?.roleId == 1 ? false : true}
                        required
                        id="amortizacion"
                        name="amortizacion"
                        style={{ textAlign: "left" }}
                        value={formik.values.amortizacion}
                        onChange={formik.handleChange}
                      >
                        <MenuItem value="cuotaConstante">
                          Cuota constante
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="create-credit-input-row">
                    <FormControl className={classes.formControl} style={{ width: "70%" }}>
                      <InputLabel>Estado</InputLabel>
                      <Select
                        label="Estado"
                        disabled={props.user?.roleId == 1 ? false : true}
                        required
                        id="estado"
                        name="estado"
                        style={{ textAlign: "left" }}
                        value={formik.values.estado}
                        onChange={formik.handleChange}
                      >
                        <MenuItem value="noAprobado">No Aprobado</MenuItem>
                        <MenuItem value="aprobado">Aprobado</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      disabled={props.user?.roleId == 1 ? false : true}
                      required
                      className="create-credit-input"
                      label="Tasa de interés"
                      type="number"
                      pattern="^-?[0-9]\d*\,?\d*$"
                      id="interes"
                      value={formik.values.interes}
                      onChange={formik.handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      label="Vencimiento Final"
                      style={{ width: "70%" }}
                      variant="standard"
                      value={formatDateLocal(formik.values.expiryDate)}
                      InputProps={{
                        readOnly: true,
                      }}
                      inputProps={{
                        style: { cursor: "default" }
                      }}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      label="Fecha hipoteca"
                      style={{ width: "70%" }}
                      variant="standard"
                      disabled={props.user?.roleId !== 1}
                      value={formatDateLocal(formik.values.mortgageDate)}
                      slotProps={{
                        htmlInput: { style: { caretColor: "black" } },
                        input: {
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="start">
                              <ReactDatePicker
                                id="mortgageDate"
                                locale="es"
                                disabled={props.user?.roleId !== 1}
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                selected={parseDate(formik.values.mortgageDate)}
                                onChange={(value) => formik.setFieldValue("mortgageDate", value)}
                                customInput={<DatePickerState />}
                              />
                            </InputAdornment>
                          ),
                        }
                      }}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      disabled={props.user?.roleId == 1 ? false : true}
                      className="create-credit-input"
                      label="Número de escritura"
                      type="number"
                      pattern="^-?[0-9]\d*\.?\d*$"
                      id="deedNumber"
                      value={formik.values.deedNumber}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      disabled={props.user?.roleId == 1 ? false : true}
                      className="create-credit-input"
                      label="Notaría"
                      id="notary"
                      value={formik.values.notary}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="create-credit-input-row">
                    <TextField
                      disabled={props.user?.roleId == 1 ? false : true}
                      className="create-credit-input"
                      id="landRegistry"
                      type="number"
                      pattern="^-?[0-9]\d*\.?\d*$"
                      label="Número matricula inmobiliaria"
                      value={formik.values.landRegistry}
                      onChange={formik.handleChange}
                    />
                  </div>
                  
                 

                  {props.exists && formik.values.estado == "aprobado" && (
                    <>
                      <div className="create-credit-input-row">
                        <TextField
                          label="Fecha Desembolso"
                          style={{ width: "70%" }}
                          variant="standard"
                          disabled={props.user?.roleId !== 1}
                          value={formatDateLocal(formik.values.fechaDesembolsoReal)}
                          slotProps={{
                            htmlInput: { style: { caretColor: "black" } },
                            input: {
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <ReactDatePicker
                                    id="fechaDesembolsoReal"
                                    locale="es"
                                    disabled={props.user?.roleId !== 1}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={parseDate(formik.values.fechaDesembolsoReal)}
                                    onChange={(value) =>
                                      formik.setFieldValue("fechaDesembolsoReal", value)
                                    }
                                    customInput={<DatePickerState />}
                                  />
                                </InputAdornment>
                              ),
                            }
                          }}
                        />
                      </div>
                      <div className="create-credit-input-row">
                        <TextField
                          label="Fecha Aprobación"
                          style={{ width: "70%" }}
                          variant="standard"
                          disabled={props.user?.roleId !== 1}
                          value={formatDateLocal(formik.values.fechaAprobacion)}
                          slotProps={{
                            htmlInput: { style : { caretColor: "black "} },
                            input: {
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <ReactDatePicker
                                    id="fechaAprobacion"
                                    locale="es"
                                    disabled={props.user?.roleId !== 1}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={parseDate(formik.values.fechaAprobacion)}
                                    onChange={(value) => formik.setFieldValue("fechaAprobacion", value)}
                                    customInput={<DatePickerState />}
                                  />
                                </InputAdornment>
                              ),
                            }
                          }}
                        />
                      </div>
 {/* Control de Liquidación Masiva */}
 {props.exists && (
  <div className="create-credit-input-row" style={{ marginTop: '0.5rem', marginBottom: '0.5rem', position: 'relative' }}>
    <FormControlLabel
      control={
        <Checkbox
          checked={formik.values.blockMassiveLiq || false}
          onChange={(e) => {
            updateblockMassiveLiq(e, e.target.checked, formik.setFieldValue);
          }}
          disabled={!([1, 2].includes(props.user?.roleId))}
        />
      }
      label="Bloquear liquidación automática"
    />
    
    {formik.values.blockMassiveLiq && (
      <div style={{
        position: 'absolute',
        top: '50%',
        left: 50,
        marginTop: '0.25rem',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
        padding: '0.5rem',
        color: '#856404',
        fontSize: '0.875rem',
        maxWidth: '400px',
        zIndex: 2000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
      }}>
        <strong>⚠️ Liquidación automática desactivada</strong>
        <br />
        Este crédito NO será procesado cuando se ejecute 
        "Liquidar todos los créditos" desde el menú Documentos.
        <br />
        Las liquidaciones deben realizarse manualmente para este crédito.
      </div>
    )}
  </div>
)}
                    </>
                  )}
                  <div className="create-credit-input-row"></div>
                </div>
                {formik.values.pasoEdicionLocal > 0 && (
                  <>
                    <Form.Label className="formTitle">Liquidación</Form.Label>
                    <br />
                    <div style={{ width: "100%", margin: "1rem 0 2rem 0" }}>
                      <table
                        id="table"
                        name="liq"
                        className="table table-hover bg-white table-striped"
                      >
                        <tbody>
                          <tr>{renderTableHeaderLiquidaciones()}</tr>
                          {props.moneda === "uvr"
                            ? renderTableDataLiquidacionesUVR()
                            : renderTableDataLiquidaciones()}
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <Form.Label className="formTitle">
                        Abonos registrados
                      </Form.Label>
                      <div
                        className="acordeonDiv"
                        style={{ width: "100%", margin: "1rem 0 2rem 0" }}
                      >
                        {renderTableDataYear()}
                      </div>
                    </div>
                    <Form.Label className="formTitle">Proyección</Form.Label>
                    <div className="leftBtn">
                      <Button
                        sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                        variant="contained"
                        id="showProy"
                        onClick={showProy}
                      >
                        Mostrar Proyección
                      </Button>
                    </div>
                    <br></br>
                    <div id="proyTable" className="group">
                      <table id="table">
                        <tbody>
                          <tr>{renderTableHeaderProyeccion()}</tr>
                          {props.moneda === "uvr"
                            ? renderTableDataProyeccionUVR()
                            : renderTableDataProyeccion()}
                        </tbody>
                      </table>
                    </div>

                   {/*  <Button
                      sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                      variant="contained"
                      disabled={
                        JSON.parse(
                          atob(
                            window.sessionStorage
                              .getItem("localToken")
                              .split(".")[1]
                          )
                        ).roleId == 1
                          ? false
                          : true
                      }
                      onClick={addCuota}
                    >
                      Añadir cuota
                    </Button> */}

                    <Button
                      sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                      style={{ marginLeft: "5%" }}
                      disabled={
                      [1, 2].includes(
                        JSON.parse(
                          atob(
                            window.sessionStorage
                              .getItem("localToken")
                              .split(".")[1]
                          )
                        ).roleId
                      ) ? false : true
                    }
                      variant="contained"
                      onClick={handleShowLiq}
                    >
                      Liquidar
                    </Button>

                    <Button
                      variant="contained"
                      onClick={paymentsAplicationDialog}
                      disabled={
                        JSON.parse(
                          atob(
                            window.sessionStorage
                              .getItem("localToken")
                              .split(".")[1]
                          )
                        ).roleId == 1
                          ? false
                          : true
                      }
                      sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                      style={{ marginLeft: "5%" }}
                    >
                      Documentos
                    </Button>

                    <Button
                      sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                      variant="contained"
                      type="submit"
                      disabled={
                        JSON.parse(
                          atob(
                            window.sessionStorage
                              .getItem("localToken")
                              .split(".")[1]
                          )
                        ).roleId == 1
                          ? false
                          : true
                      }
                      onClick={handleShowDeleteCredit}
                      style={{ marginLeft: "5%" }}
                    >
                      Eliminar crédito
                    </Button>

                    <div className="leftBtn">
                      <Button
                        sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                        variant="contained"
                        onClick={handleShowDownload}
                        style={{ marginTop: "1rem" }}
                      >
                        Descargar estado de cuenta
                      </Button>

                      <Button
                        sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                        variant="contained"
                        onClick={(e) => {
                          e.preventDefault();
                          generatePDFProyeccion(props, { table, formatter, toFixed, logo, footer, apiMethods });
                        }}
                        style={{ marginLeft: "5%", marginTop: "1rem" }}
                      >
                        Descargar proyeccion
                      </Button>

                      <Button
                        sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                        variant="contained"
                        onClick={handleShowPayment}
                        style={{ marginLeft: "5%", marginTop: "1rem" }}
                      >
                        Descargar aplicación de pagos
                      </Button>

                      <Modal
                        centered={true}
                        show={props.showModalDownload}
                        onHide={handleCloseDownload}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Descargar estado de cuenta</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Por favor indique el periodo a descargar
                        </Modal.Body>
                        <Form.Control
                          as="select"
                          name="estado"
                          className="selectorDownload"
                          value={props.estado}
                          onChange={changeHandler}
                        >
                          {createSelectItems()}
                        </Form.Control>{" "}
                        <Modal.Footer>
                          <Button
                            type="submit"
                            sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', color: 'white' }
                            }}
                            style={{ marginRight: "15px" }}
                            disabled={
                              JSON.parse(
                                atob(
                                  window.sessionStorage
                                    .getItem("localToken")
                                    .split(".")[1]
                                )
                              ).roleId == 1
                                ? false
                                : true
                            }
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              generateInitialPDF(props, { 
                                formatter, 
                                toFixed, 
                                fixTimeZone, 
                                toast, 
                                logo, 
                                footer, 
                                apiMethods,
                                axios,
                                pdfMake
                              });
                            }}
                          >
                            Descargar estado de cuenta inicial
                          </Button>

                          <Button
                            type="submit"
                            sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              
                              generatePDF(props, { 
                                table, 
                                formatter, 
                                toFixed, 
                                fixTimeZone, 
                                parseFlexibleDate, 
                                toast, 
                                setState, 
                                delPago, 
                                logo, 
                                footer, 
                                apiMethods 
                              });
                            }}
                          >
                            Descargar
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        centered={true}
                        show={props.showModalLiq}
                        onHide={handleCloseLiq}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Liquidar credito según periodo
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {periodosLiq.length === 0 ? (
                            <div style={{
                              backgroundColor: '#ffcdcd',
                              border: '1px solid #ff0707',
                              borderRadius: '4px',
                              padding: '1rem',
                              color: '#000000'
                            }}>
                              <strong>No hay periodos disponibles para liquidar</strong>
                              <p style={{ 
                                marginTop: '0.5rem', 
                                marginBottom: 0, 
                                fontSize: '0.9rem',
                                lineHeight: '1.4'
                              }}>
                                Los periodos solo pueden liquidarse después de su fecha de finalización.
                                {(() => {
                                  // Buscar el primer periodo no liquidado en la proyección
                                  if (!props.proyeccion || props.proyeccion.length === 0) return null;
                                  
                                  const proximoPeriodo = props.proyeccion.find(p => !p.liquidado);
                                  if (!proximoPeriodo) return null;
                                  
                                  const fechaFin = new Date(proximoPeriodo.fechaFin);
                                  const fechaIni = new Date(proximoPeriodo.fechaIni);
                                  const months = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
                                  
                                  return (
                                    <>
                                      <br/><br/>
                                      <strong>Periodo Vigente:</strong>{' '}
                                      {("0" + (fechaIni.getDate()+1)).slice(-2)} {months[fechaIni.getMonth()]} {fechaIni.getFullYear()} al{' '}
                                      {("0" + fechaFin.getDate()).slice(-2)} {months[fechaFin.getMonth()]} {fechaFin.getFullYear()}
                                      <br/>
                                      <strong>Liquidación disponible a partir del:</strong>{' '}
                                      {fechaFin.toLocaleDateString('es-CO', {
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric'
                                      })}
                                    </>
                                  );
                                })()}
                              </p>
                            </div>
                          ) : (
                            <>
                              <p>Por favor indique el periodo a liquidar</p>
                              <Form.Control
                                as="select"
                                name="estado"
                                className="selectorLiq"
                                value={props.estado}
                                onChange={changeHandler}
                              >
                                {createSelectItemsLiq()}
                              </Form.Control>
                            </>
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            type="submit"
                            sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                            variant="contained"
                            onClick={(e) => relativePayment(e, false)}
                            disabled={periodosLiq.length === 0}
                          >
                            Liquidar
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        centered={true}
                        show={props.showModalPayment}
                        onHide={handleClosePayment}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Descargar aplicación de pagos
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Por favor indique el rango de periodos que se quieren
                          descargar
                        </Modal.Body>
                        <Stack style={{ marginTop: "1rem" }} spacing={3}>
                          <ReactDatePicker
                            style={{ width: "60%", marginLeft: "0.5rem" }} 
                            locale="es"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={parseDate(props.startDate)}
                            onChange={(date) => handleChangeDatePickerPayment(date, "start")}
                            customInput={
                              <TextField 
                                label="Fecha inicio" 
                                variant="outlined"
                                sx={{ 
                                  marginLeft: "0.5rem", 
                                  marginRight: "1rem",
                                  width: 'calc(100% - 1.5rem)' 
                                }}
                              />
                            }
                          />
                          <ReactDatePicker
                            style={({ width: "60%" }, { marginLeft: "0.5rem" })}
                            locale="es"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={parseDate(props.endDate)}
                            onChange={(date) =>
                              handleChangeDatePickerPayment(date, "end")
                            }
                            disableFuture
                            customInput={
                              <TextField
                                label="Fecha fin"
                                variant="outlined"
                                sx={{
                                  marginLeft: "0.5rem",
                                  marginRight: "1rem",
                                  width: 'calc(100% - 1.5rem)'
                                }}
                              />
                            }
                          />
                        </Stack>
                        <Modal.Footer>
                          <Button
                            type="submit"
                            sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                            variant="contained"
                            onClick={downloadPaymentsAplication}
                          >
                            Descargar
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>

                    {
                      //nueva row en componente antiguo
                    }
                    <div></div>
                  </>
                )}

                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "1.5rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  <Button
                    variant="contained"
                    disabled={
                      JSON.parse(
                        atob(
                          window.sessionStorage
                            .getItem("localToken")
                            .split(".")[1]
                        )
                      ).roleId == 1
                        ? false
                        : true
                    }
                    style={{ width: "11rem", height: "2.5rem" }}
                    sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                    type="submit"
                  >
                    Enviar
                  </Button>
                </div>
              </form>
              <br></br>
              <Dialog
                open={props.showPaymentsAplicationDialog}
                onClose={paymentsAplicationDialog}
                fullWidth={true}
                maxWidth="md"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Documentos anexos al crédito"}
                </DialogTitle>
                <DialogContent>
                  <div
                    style={{
                      height: 250,
                      width: "100%",
                      margin: "1rem 0 2rem 0",
                    }}
                  >
                    <DataGrid
                      rows={props.files}
                      columns={clientsColumns}
                      pageSize={5}
                      disableSelectionOnClick
                    />
                  </div>
                </DialogContent>
                <DialogActions>
                  <input
                    style={{ display: "none" }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={uploadFile}
                  />
                  <label htmlFor="raised-button-file">
                    <Button style={{ marginRight: "1rem" }} component="span">
                      Subir archivo
                    </Button>
                  </label>
                  <label htmlFor="demo">
                    <Button
                      component="span"
                      onClick={paymentsAplicationDialog}
                      autoFocus
                    >
                      Cerrar
                    </Button>
                  </label>
                </DialogActions>
              </Dialog>
              {props.exists && (
                <Form>
                  <Modal
                    centered={true}
                    show={props.showModalDeleteCredito}
                    onHide={handleCloseDeleteCredit}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Eliminación de crédito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      ¿Está seguro que desea eliminar el crédito?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        type="submit"
                        color="red"
                        variant="contained"
                        onClick={removeCredit}
                      >
                        Aceptar
                      </Button>
                      <Button
                        type="submit"
                        color="red"
                        variant="contained"
                        onClick={handleCloseDeleteCredit}
                      >
                        Cancelar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    centered={true}
                    show={props.showModalDeletePayment}
                    onHide={handleCloseDeletePayment}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Eliminación de pago</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      ¿Está seguro que desea eliminar el pago?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        style={{ marginRight: "5%" }}
                        type="submit"
                        color="red"
                        variant="contained"
                        onClick={delPago}
                      >
                        Aceptar
                      </Button>
                      <Button
                        type="submit"
                        color="red"
                        variant="contained"
                        onClick={handleCloseDeletePayment}
                      >
                        Cancelar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Form>
              )}
            </div>
          </div>
          <br></br>
          {props.pasoEdicionLocal >= 2 &&
            [1, 2].includes(
              JSON.parse(
                atob(window.sessionStorage.getItem("localToken").split(".")[1])
              ).roleId
            ) && (
              <div className="card">
                <Form>
                  <Row>
                    <Col>
                      <Form.Label className="formTitle">
                        Monto del pago
                      </Form.Label>
                      <NumericFormat 
                        customInput={Form.Control}
                        name="montoPago"
                        id="currency-fieldPago"
                        value={props.montoPago}
                        thousandSeparator="."
                        decimalSeparator=","
                        disabled={isBlocked()}
                        // ✅ AGREGAR ESTE HANDLER
                        onValueChange={(values) => {
                          
                          setState({ montoPago: values.value });
                        }}
                      />
                    </Col>

                    <Col>
                      <Form.Label className="formTitle">
                        Fecha del pago
                      </Form.Label>
                      <br />
                      <ReactDatePicker
                        selected={parseDate(props.fechaPago)}
                        onChange={handleChangeDatePicker}
                        locale="es"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="datepicker-fechaPago"
                        onChangeRaw={(e) => e.preventDefault()}
                      />
                    </Col>
                    <Col>
                      <br></br>
                      {/* <form> */}
                      {pagoBlockedByPrev && (
                        <div
                          style={{
                            marginBottom: "0rem",
                            color: "#000000",
                            fontweight: "bold",
                            backgroundColor: "#ff5867",
                            padding: "3px",
                            borderRadius: "4px",
                          }}
                        >
                          ⚠️ Existe un periodo vencido sin liquidar. Revise y
                          liquide el periodo anterior antes de procesar este
                          pago.
                        </div>
                      )}
                    {!(isBlocked() || pagoBlockedByPrev) && (
                      <Button
                        type="button"
                        sx={{
                              backgroundColor: 'rgb(238, 238, 238)',
                              color: "black",
                              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
                            }}
                        variant="contained"
                        onClick={(e) => {
                          e.preventDefault();
                          // Usar handleShow que hace la verificación en backend
                          handleShow(e);
                        }}
                        style={{
                          alignSelf: 'flex-end',
                          margin: '18px 0px 18px 0px',
                        }}
                      >
                        Enviar pago
                      </Button>
                    )}
                      <Modal
                        centered={true}
                        show={props.showModal}
                        onHide={handleClose}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Pago fuera de plazo definido
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {props.mesesRequeridos && (
                            <p
                              style={{
                                marginBottom: "1rem",
                                color: "#856404",
                                backgroundColor: "#fff3cd",
                                padding: "0.75rem",
                                borderRadius: "4px",
                              }}
                            >
                              ℹ️ Este pago requiere extender la proyección en{" "}
                              <strong>{props.mesesRequeridos} mes(es)</strong>.
                            </p>
                          )}
                          ¿Desea extender la proyección y procesar el pago, o
                          enviar el pago con seguros en ceros?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            type="submit"
                            color="red"
                            variant="contained"
                            onClick={definirSegurosModal}
                          >
                            Extender proyección
                          </Button>
                          <Button
                            type="submit"
                            color="red"
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              submitHandlerPagos(e);
                            }}
                          >
                            Enviar pago con seguros en ceros
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </Col>
                  </Row>
                </Form>
              </div>
            )}
        </div>
      </LocalizationProvider>
    </React.Fragment>
  ) : (
    <AccessDenied />
  );
};

export default Credits;
